import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgVentilatie = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F170B8"
      d="M32.55 5.99H7.45a1.46 1.46 0 0 0-1.46 1.46v25.1c0 .806.654 1.46 1.46 1.46h25.1a1.46 1.46 0 0 0 1.46-1.46V7.45a1.46 1.46 0 0 0-1.46-1.46"
    />
    <path
      fill="#F8BADD"
      d="M30.93 8H9.07C8.48 8 8 8.48 8 9.07v21.86c0 .59.48 1.07 1.07 1.07h21.86c.59 0 1.07-.48 1.07-1.07V9.07C32 8.48 31.52 8 30.93 8"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M20.5 9v22h-1V9z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M31 20.5H9v-1h22z"
      clipRule="evenodd"
    />
    <path
      fill="#F170B8"
      d="M14 12a2 2 0 1 1 0 4 2 2 0 0 1 0-4m0-1a3 3 0 1 0 0 5.999A3 3 0 0 0 14 11M26 17a3 3 0 1 0 0-6 3 3 0 0 0 0 6M16 24v4h-4v-4zm1-1h-6v6h6zM27 24l-.79 2h1.07l1.19-3h-4.75l1.18 3H26l-.79-2zM23.72 29h4.73l-1.19-3H24.9z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgVentilatie);

export default ForwardRef;
